import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgFlag = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M3.968 3.14a1 1 0 0 1 1 1V22.5a1 1 0 1 1-2 0V4.14a1 1 0 0 1 1-1M20.03 3.14a1 1 0 0 1 1 1v10.328a1 1 0 0 1-2 0V4.14a1 1 0 0 1 1-1"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M7.984 3.5c-1.24 0-2.43.486-3.316 1.354a1 1 0 1 1-1.4-1.428 6.737 6.737 0 0 1 9.432 0 4.737 4.737 0 0 0 6.632 0 1 1 0 1 1 1.4 1.428 6.737 6.737 0 0 1-9.432 0A4.74 4.74 0 0 0 7.984 3.5M7.984 13.828c-1.24 0-2.43.486-3.316 1.354a1 1 0 0 1-1.4-1.428 6.737 6.737 0 0 1 9.432 0 4.737 4.737 0 0 0 6.632 0 1 1 0 1 1 1.4 1.428 6.737 6.737 0 0 1-9.432 0 4.74 4.74 0 0 0-3.316-1.354"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgFlag);
export default Memo;
